// extracted by mini-css-extract-plugin
export var activityContainer = "_ik-0";
export var typingIndicatorContainer = "_ik-1";
export var typingIndicatorDot = "_ik-2";
export var wave = "_ik-3";